import React, { useEffect, useState } from 'react';
import { CModal, CModalHeader, CModalTitle, CModalBody, CModalFooter, CButton, CInput } from '@coreui/react';
import { useDispatch, useSelector } from 'react-redux';
import { SelectActiveNode, LoadSelectedOrg } from '../../../store/actions/orgHierarchy.action';
import {
  selectOrgHierarchyActiveNode,
  selectOrgHierarchyLoadingState,
  selectOrgHierarchySelectedOrg,
} from '../../../store/selectors/orgHierarchy.selectors';
import { getSelectedOrgId } from '../../constants/orgHierarchy.constants';
import { selectUserOrganization } from '../../../store/selectors/store.selectors';
import OrgHierarchy from './OrgHierarchy';
import LoadingOverlay from '../LoadingOverlay/LoadingOverlay';
import { selectUserProfile } from '../../../store/selectors/profile.selectors';
import isVisibleEl from '../../utils/ui-utils';

interface OrgHierarchyModalProps {
  show: boolean;
  close: () => void;
}

const OrgHierarchyModal = ({ show, close }: OrgHierarchyModalProps) => {
  const dispatch = useDispatch();
  const activeNode = useSelector(selectOrgHierarchyActiveNode);
  const profile = useSelector(selectUserProfile)
  const selectedOrg = useSelector(selectOrgHierarchySelectedOrg);
  const org = useSelector(selectUserOrganization);
  const isLoading = useSelector(selectOrgHierarchyLoadingState);
  const [currentQuery, setCurrentQuery] = useState('');

  const handleSelect = () => {
    close();
    dispatch(new LoadSelectedOrg(activeNode._id));
    localStorage.setItem(getSelectedOrgId(profile.id, org._id), `${activeNode?._id}`);
  };

  const handleClose = () => {
    close();
    if (selectedOrg && activeNode && selectedOrg._id !== activeNode._id) {
      dispatch(new SelectActiveNode(selectedOrg));
    }
  };

  const handleQueryChange = (event) => {
    setCurrentQuery(event.target.value);
  };

  useEffect(() => {
    if (activeNode) {
      setCurrentQuery('');
      requestAnimationFrame(() => {
        setTimeout(() => {
          const els = document.querySelectorAll('.glympse-orgHierarchy-node-item.bg-color-active');
          const container = document.querySelector('#orgHierarchy');
          const lastActiveEl = els[els?.length - 1];
          const visible = isVisibleEl(lastActiveEl, container)
          if (visible) {
            container.scroll({
              left: container.scrollWidth,
              behavior: 'smooth'
            });
          } else {
            lastActiveEl.scrollIntoView({ behavior: "smooth", block: "center", inline: "end" });
          }
        });
      });
    }
  }, [activeNode]);

  return (
    <CModal id="org-hierarchy-modal" className="mt-5 pt-5 glympse-orgHierarchy-modal" show={ show } onClose={ handleClose }>
      <CModalHeader closeButton>
        <div className='d-flex w-100 align-items-center'>
          <CModalTitle>
            Organization
          </CModalTitle>
          <div className="ml-auto">
            <CInput placeholder="Search" value={currentQuery} onChange={handleQueryChange} />
          </div>
        </div>
      </CModalHeader>
      <CModalBody className="glympse-orgHierarchy-modal-body">
        {
          isLoading ? (
            <LoadingOverlay />
          ) : null
        }
        <OrgHierarchy filterQuery={currentQuery} />
      </CModalBody>
      <CModalFooter className="glympse-footer">
        <div className='glympse-btnWrapper'>
            <CButton
              className="pl-5 pr-5 bg-color-orange pl-5 pr-5 border-0 roundedBtn roundBottomShadow"
              color="info"
              onClick={ handleSelect }
            >
              Select
            </CButton>
          </div>
        <div className='glympse-btnWrapper'>
          <CButton
            className="glympse-cancelBtn"
            color="light"
            shape="rounded-pill"
            variant="ghost"
            onClick={ handleClose }
          >
            Cancel
          </CButton>
        </div>
      </CModalFooter>
    </CModal>
  );
}

export default OrgHierarchyModal;
